import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

// Parse Firebase configuration from environment variable
// Expects VITE_FIREBASE_CONFIG to contain Firebase config JSON object
let firebaseConfig: any;

try {
  const configString = import.meta.env.VITE_FIREBASE_CONFIG;
  
  if (!configString) {
    throw new Error('VITE_FIREBASE_CONFIG environment variable is not set. Please check your .env file.');
  }

  firebaseConfig = JSON.parse(configString);
} catch (error) {
  if (error instanceof SyntaxError) {
    throw new Error(`Failed to parse VITE_FIREBASE_CONFIG as JSON: ${error.message}. Please ensure it contains valid JSON.`);
  }
  throw error;
}

// Validate required Firebase config keys
const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'appId'];
const missingKeys = requiredKeys.filter(key => !firebaseConfig[key]);

if (missingKeys.length > 0) {
  throw new Error(`Missing required Firebase configuration keys: ${missingKeys.join(', ')}. Please check your VITE_FIREBASE_CONFIG.`);
}

const app = initializeApp(firebaseConfig);

export const database = getDatabase(app);
export const auth = getAuth(app);

export default app;
